<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center justify-between margin-bottom-sm page-title">
            <b>入会申请单</b>
        </div>
        <div class="invitation-box">
            <div class="code-img" ref="newImg">
                <img :src="imgUrl + 'qrcode/qyfh_' + mid +'.png?v='+new Date().getTime()" >
            </div>
            <div class="flex justify-center margin-tb">
                <a :href="imgUrl + 'qrcode/qyfh_' + mid +'.png?v='+new Date().getTime()" target="_blank" download="asd.png">
                    <el-button round class="blue-btn">下载分支机构申请二维码</el-button>
                </a>
            </div>
            <div class="copy-box">
                <div class="copy-box-bg">
                    <div class="copy-box-left">
                        <div>网址 : &nbsp;</div>
                        <div ref="copy">{{yuMing + 'binvitation/' + mid }}</div>
                    </div>
                    <div class="copy-box-right" @click="copy"><el-button round class="blue-btn">复制分支机构申请链接</el-button></div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import {IMAGE_PATH,HOSTPATH} from "@/config";

export default {
    name: "invitation",
    data() {
        return {
            imgUrl: '',
          yuMing: '',
            mid:''
        }
    },
    computed:{
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [8, 1], '分支机构邀请')
        this.mid = this.user.mid
        this.imgUrl = IMAGE_PATH
        this.yuMing = HOSTPATH
    },
    components: {

    },
    methods: {
        setImage() {
            html2canvas(this.$refs.newImg, {
                backgroundColor: null
            }).then((canvas) => {
                this.dataURL = canvas.toDataURL("image/png");
            })
        },

        // 邀请函下载
        downs() {
            // 保存二维码
            var url = this.yuMing + 'qrcode/zc_' + this.mid +'.png'
            var a = document.createElement('a')
            a.download = name || 'pic'
            a.href = url
            a.click()
        },

        // 复制地址
        copy() {
            let Url2 = this.$refs.copy.innerText
            let oInput = document.createElement('input')
            oInput.value = Url2
            document.body.appendChild(oInput)
            oInput.select() // 选择对象
            document.execCommand("Copy") // 执行浏览器复制命令
            oInput.className = 'oInput'
            oInput.style.display = 'none'
            this.$message({
                message: '复制网址成功',
                type: 'success'
            })
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

.classifys {
    margin-top: 20px;
    .classify {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #ffb400;
        border-radius: 6px 0  0 6px;
        color: #ffb400;
        &.active {
            background: #ffb400;
            color: #FFFFFF;
            border-radius: 0 6px 6px 0;

        }
    }
}
    .invitation-box{
        width: 520px;
        margin: 30px auto;
        .code-img{
            img{
                display: block;
                width: 300px;
                margin: 0 auto;
            }
        }
        .copy-box {
            width: 572px;
            height: 60px;
            margin: 0 auto;
            background:#f3f7fb;
            display: flex;
            justify-content: center;
            align-items: center;

            .copy-box-bg {
                width: 548px;
                height: 42px;
                background-color: #ffffff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 21px;

                .copy-box-left {
                    margin-left: 15px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .copy-box-right {
                    cursor: pointer;
                }
            }
        }
    }
</style>
